import type { ComponentType, ReactNode } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { I18nextProvider } from 'react-i18next';
import { SWRConfig } from 'swr';

import { swrConfig } from './http/swr-config';
import i18nInstance from './i18n/i18n.config';
import { theme } from './theme';

export interface AppProvidersProps {
  /** HashRouter no app, MemoryRouter no Storybook e nos testes. */
  router: ComponentType<{ children?: ReactNode }>;
  children?: ReactNode;
}

/**
 * Declaração única dos providers globais do React. O Router entra por injeção
 * para que app, Storybook e testes compartilhem a cadeia sem compartilhar o
 * mecanismo de navegação.
 */
export function AppProviders({ router: Router, children }: AppProvidersProps) {
  return (
    <SWRConfig value={swrConfig}>
      <I18nextProvider i18n={i18nInstance}>
        <ThemeProvider theme={theme}>
          <Router>{children}</Router>
        </ThemeProvider>
      </I18nextProvider>
    </SWRConfig>
  );
}
